<template>
  <div class="pres-grid-container">
    <div class="pres-words">
      <h3
        v-for="(word, i) in player.words"
        :key="i"
        :style="`width: calc(100vw / ${nbOfPlayers});`"
      >
        {{ word }}
      </h3>
    </div>
    <div :class="`pres-pseudo`">
      <h2
        :class="` ${player.isConnected ? '' : 'disconnected'}`"
        :style="`width: calc(100vw / ${nbOfPlayers});`"
      >
        {{ player.name }}
      </h2>
    </div>
    <div :class="`pres-avatar ${player.isConnected ? '' : 'disconnected'}`">
      <img
        :class="` ${player.isConnected ? '' : 'disconnected'}`"
        :src="avatars[player.avatar]"
        alt="avatar"
      />
    </div>
    <div class="pres-votes">
      <div class="vote-placeholder" v-for="(other, id) in playerById" :key="id">
        <b-tooltip :label="other.name" type="is-dark">
          <img
            :src="avatars[other.avatar]"
            v-if="other.vote == playerId"
            alt="avatar"
            :style="
              `background-color: ${
                other.validated ? 'green' : 'red'
              }; width:inherit; border-radius: 5px`
            "
          />
        </b-tooltip>
      </div>
    </div>
    <div class="pres-actions">
      <b-tooltip label="vote Imposteur" type="is-danger">
        <div class="voteImposteur" v-if="self.vote == playerId">
          I
        </div>
      </b-tooltip>
      <b-tooltip label="vote Mr. White" type="is-dark">
        <div class="voteMrWhite" v-if="self.voteMrWhite == playerId && mrWhite">
          W
        </div>
      </b-tooltip>
      <button
        class="button is-medium is-danger"
        v-if="
          playerId != sessionId &&
            self.voteMrWhite != playerId &&
            self.vote != playerId &&
            !self.validated
        "
        @click="vote()"
      >
        vote
      </button>
      <button
        class="button is-medium is-dark"
        v-if="
          playerId != sessionId &&
            self.voteMrWhite != playerId &&
            self.vote != playerId &&
            !self.validated &&
            mrWhite
        "
        @click="voteMrWhite()"
      >
        Mr. White
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "Presentation",
  props: {
    playerId: String
  },
  methods: {
    vote() {
      this.sendMessageToRoom("voteFor", this.playerId);
    },
    voteMrWhite() {
      this.sendMessageToRoom("voteMrWhite", this.playerId);
    }
  },
  computed: {
    ...mapState("colyseus", ["playerById", "sessionId", "mrWhite"]),
    ...mapState(["avatars"]),
    ...mapGetters("colyseus", ["self"]),
    player() {
      return this.playerById[this.playerId];
    },
    voted() {
      return this.self.vote != "";
    },
    nbOfPlayers() {
      return Object.keys(this.playerById).length;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/palette.scss";
.pres-grid-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto auto 1fr 7em;
  gap: 1px 1px;
  grid-template-areas: "words" "pres-pseudo" "pres-avatar" "pres-votes" "actions";
  height: 100%;
  overflow-y: visible;
  @media only screen and (max-width: 800px) {
    width: 70vw !important;
    flex-shrink: 0;
  }
}

.pres-words {
  grid-area: words;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.vote-placeholder {
  height: 3vw;
  width: 3vw;
  border-radius: 5px;
  background-color: $intru-3-hex;
  @media only screen and (max-width: 800px) {
    height: 10vw;
    width: 10vw;
  }
}

.voteMrWhite {
  height: 40px;
  width: 40px;
  font-size: 24px;
  font-weight: bold;
  background-color: #363636;
  border-radius: 5px;
  color: white;
}

.voteImposteur {
  height: 40px;
  width: 40px;
  font-size: 24px;
  font-weight: bold;
  background-color: #ff3860;
  border-radius: 5px;
  color: white;
}

h2 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

h3 {
  overflow: hidden;
  text-overflow: ellipsis;
  @media only screen and (max-width: 800px) {
    width: 100% !important;
  }
}
.pres-pseudo {
  grid-area: pres-pseudo;
  font-size: 1.5em;
}

.pres-pseudo > h2 {
  @media only screen and (max-width: 800px) {
    width: 100% !important;
  }
}

.pres-avatar {
  grid-area: pres-avatar;
}

.pres-votes {
  grid-area: pres-votes;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.pres-actions {
  grid-area: actions;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  width: 100%;
}
.pres-actions > button {
  width: 10vw;
}

.pres-avatar > img {
  width: 5vw;
  @media only screen and (max-width: 800px) {
    width: 20vw;
  }
}
</style>
